import script from "./Sidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./Sidebar.vue?vue&type=script&lang=ts&setup=true"

import "./Sidebar.vue?vue&type=style&index=0&id=643a4246&lang=css"
import "./Sidebar.vue?vue&type=style&index=1&id=643a4246&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\viglacera\\nhathau\\fe\\source005\\vig_contructor_fe_v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-643a4246"]])

export default __exports__